import { environment } from '../../../environments/environment';
import { Injector } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';


export class Base {
    public spinner: boolean = false;
    public NgSpinner: NgxSpinnerService;
    public URL_BASE = environment.url_base;
    public URL_BASE_IMAGE = environment.url_base_image;
    public type_vehicle = localStorage.getItem('typeVehicle');

    constructor(injector: Injector) {
      this.NgSpinner = injector.get(NgxSpinnerService);
    }

    GetUser(): any {
        return JSON.parse(localStorage.getItem('UserGoCar'));
    }

    GetSettings() {
        return JSON.parse(localStorage.getItem('Settings'));
    }

}
